import { Box, Button, Stack, Typography, useTheme } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import CarrotLogo from "../../resources/images/carrot-logo.svg"
import CirclePattern from "../../resources/images/circles-pattern.svg"
import { useDigitalFrontDoorBreakpointViews } from "../../hooks/useDigitalFrontDoorBreakpointViews"
import { CarrotRxExtendSupportMailToHref } from "../shared/CarrotRxExtendSupportEmailLink"
export function Footer(): JSX.Element {
  const theme = useTheme()
  const { isMobileView } = useDigitalFrontDoorBreakpointViews()
  const responsiveHeight = isMobileView ? "19.5rem" : "28rem"
  const intl = useIntl()

  return (
    <Box
      sx={{
        background: theme.palette.text.secondary
      }}
      width="100%"
      minHeight={responsiveHeight}
    >
      <Stack
        direction={"row"}
        alignItems={"flex-start"}
        width="100%"
        justifyContent={"space-between"}
        gap={(theme) => theme.tokens.spacing.md}
      >
        <Stack
          direction={"column"}
          paddingTop={isMobileView ? (theme) => theme.tokens.spacing.xxxl : "6.25rem"}
          paddingLeft={isMobileView ? (theme) => theme.tokens.spacing.lg : "7.5rem"}
          paddingBottom={isMobileView ? (theme) => theme.tokens.spacing.xxxl : "4.25rem"}
          paddingRight={isMobileView ? (theme) => theme.tokens.spacing.lg : "7.5rem"}
          gap={(theme) => theme.tokens.spacing.xl}
        >
          <Box
            component="img"
            src={CarrotLogo}
            color={"white"}
            width={"10rem"}
            height={"1.5rem"}
            aria-label={intl.formatMessage({ defaultMessage: "Carrot's logo" })}
          />
          <Typography
            color={theme.palette.secondary.contrastText}
            variant="body1"
            fontSize={isMobileView ? "0.813rem" : "1.25rem"}
            minWidth={isMobileView ? "auto" : "32rem"}
          >
            <FormattedMessage
              defaultMessage="If you have questions or feedback about your benefit, email <b>ContactSupport@get-carrot.com</b>.{br}{br}Please include your name, date of birth, and ZIP code."
              values={{
                br: <br />,
                b: (boldContent) => (
                  <Typography
                    component="span"
                    color={theme.palette.secondary.contrastText}
                    fontWeight="bold"
                    fontSize={"inherit"}
                  >
                    {boldContent}
                  </Typography>
                )
              }}
            />
          </Typography>
          <Button
            id="extend-email-us-button"
            variant="outlined"
            fullWidth={false}
            href={CarrotRxExtendSupportMailToHref()}
            sx={{
              inlineSize: "fit-content",
              background: (theme) => theme.palette.background.paper,
              color: (theme) => theme.palette.text.primary
            }}
            aria-label={intl.formatMessage({ defaultMessage: "Send message to Carrot Care Team" })}
          >
            <FormattedMessage defaultMessage="Email us" />
          </Button>
        </Stack>

        {!isMobileView && <Box component={"img"} src={CirclePattern} alt="" />}
      </Stack>
    </Box>
  )
}
